import { localizer } from "@stormglass/game-localization";

import { useGameHost, useGameState } from "../game/GameContext";

export function RecoveryBanner(): React.JSX.Element | null {
  const host = useGameHost();
  const { recoveredFromBackup, storageError } = useGameState();
  if (!recoveredFromBackup && storageError === null) return null;
  return (
    <section
      className="recovery-banner"
      role="status"
      aria-labelledby="recovery-title"
    >
      <span className="recovery-banner__icon">!</span>
      <div>
        <strong id="recovery-title">{localizer.t("recovery.title")}</strong>
        <p>{storageError ?? localizer.t("recovery.detail")}</p>
      </div>
      <div className="recovery-banner__actions">
        <button
          className="button button--small"
          type="button"
          onClick={() => void host.exportDiagnostics()}
        >
          {localizer.t("recovery.export")}
        </button>
        <button
          className="icon-button"
          type="button"
          aria-label="Dismiss recovery notice"
          onClick={() => {
            host.dismissRecovery();
          }}
        >
          ×
        </button>
      </div>
    </section>
  );
}
